import { Form } from "react-bootstrap";

const FormTimeSelection = ({ field, handleTimeChange, timeValue, StudyMode, studyPermission, printable, editField }) => {
  const hours = field?.clockTimeFormat === "12"
    ? Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, "0"))
    : Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0"));

  const minutes = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const seconds = Array.from({ length: 60 }, (_, i) =>
    i.toString().padStart(2, "0")
  );

  return (
    <div className="position-relative">
      <div className="d-flex gap-3" style={{ width: `${Number(field?.fieldWidthSize || 100)}%` }} >
        <Form.Group>
          <Form.Label className="mb-1 fw-bold">Hour</Form.Label>
          <Form.Select
            className="br3"
            style={{ fontSize: 12 }}
            disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || timeValue?.status === "freezed"}
            onChange={(e) => handleTimeChange(field?.id, "hour", e.target.value)}
          >
            <option selected={(timeValue?.hour || "") === ""} value="">Select Hour</option>
            <option selected={timeValue?.hour === "UNK"} value="UNK">UNK</option>
            {hours.map((hr) => (
              <option selected={timeValue?.hour === hr} key={hr} value={hr}>
                {hr}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group>
          <Form.Label className="mb-1 fw-bold">Minute</Form.Label>
          <Form.Select
            className="br3"
            style={{ fontSize: 12 }}
            disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || timeValue?.status === "freezed"}
            onChange={(e) => handleTimeChange(field?.id, "minute", e.target.value)}
          >
            <option selected={(timeValue?.minute || "") === ""} value="">Select Minute</option>
            <option selected={timeValue?.minute === "UNK"} value="UNK">UNK</option>
            {minutes.map((min) => (
              <option key={min} selected={timeValue?.minute === min} value={min}>
                {min}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        {field?.timeFormat === "hhmmss" &&
          <Form.Group>
            <Form.Label className="mb-1 fw-bold">Second</Form.Label>
            <Form.Select
              className="br3"
              style={{ fontSize: 12 }}
              disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || timeValue?.status === "freezed"}
              onChange={(e) => handleTimeChange(field?.id, "second", e.target.value)}
            >
              <option selected={(timeValue?.second || "") === ""} value="">Select Second</option>
              <option selected={timeValue?.second === "UNK"} value="UNK">UNK</option>
              {seconds.map((sec) => (
                <option key={sec} selected={timeValue?.second === sec} value={sec}>
                  {sec}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        }
        {field?.clockTimeFormat === "12" && (
          <>
            <Form.Group>
              <Form.Label className="mb-1 fw-bold">AM/PM</Form.Label>
              <Form.Select
                className="br3"
                style={{ fontSize: 12 }}
                disabled={printable || (editField?.includes(field.id) ? false : (field?.fieldDerivation === "assigned" || field?.fieldDerivation === "derived")) || StudyMode?.startsWith("SDV") || studyPermission?.qcReadOnly || studyPermission?.liveReadOnly || timeValue?.status === "freezed"}
                onChange={(e) => handleTimeChange(field?.id, "format", e.target.value)}
              >
                <option selected={(timeValue?.format || "") === ""} value="">Select AM/PM</option>
                <option selected={timeValue?.format === "am"} value="am">AM</option>
                <option selected={timeValue?.format === "pm"} value="pm">PM</option>
              </Form.Select>
            </Form.Group>
          </>
        )}
      </div>
    </div>
  );
};

export default FormTimeSelection;
